import type { GhostAuthor, SelectResultFn } from "../../types";
import AuthorListItem from "./AuthorListItem";

interface AuthorResultsProps {
  authors: GhostAuthor[];
  selectedResult: string | null;
  setSelectedResult: SelectResultFn;
}

export default function AuthorResults({
  authors,
  selectedResult,
  setSelectedResult,
}: AuthorResultsProps) {
  if (!authors?.length) {
    return null;
  }
  return (
    <div className="border-t border-neutral-200 py-3 px-4 sm:px-7">
      <h1 className="uppercase text-xs text-neutral-400 font-semibold mb-1 tracking-wide">
        Authors
      </h1>
      {authors.map((author) => (
        <AuthorListItem
          key={author.name}
          author={author}
          selectedResult={selectedResult}
          setSelectedResult={setSelectedResult}
        />
      ))}
    </div>
  );
}
